<template>
    <div>
        <div id="uploadSheetModal" class="modal fade" role="dialog">
            <div class="modal-dialog modal-md">
                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title text-lg">
                            Upload Excel Workbook
                        </h4>
                        <button type="button" dusk="modal-close-button"
                                class="material-icons focus:outline-none text-grey-darkest hover:text-grey-darkest"
                                data-dismiss="modal">close
                        </button>
                    </div>
                    <div class="modal-body">
                        <file-pond
                            name="file"
                            ref="pond"
                            :server="server"
                            :onprocessfile="handleOnProcessFile"
                            allowRevert="false"
                            allowMultiple="false"
                            allowRemove="false"
                            class-name="my-pond"
                            dropOnElement="true"
                            dropOnPage="true"
                            label-idle="Drop or select a xlsx workbook"
                            accepted-file-types="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.oasis.opendocument.spreadsheet"
                            labelFileTypeNotAllowed="Invalid File Type"
                            fileValidateTypeLabelExpectedTypes="Only XLSX Workbooks Are Allowed."/>
                    </div>
                </div>
            </div>
        </div>
        <div id="workbook-control-container" style="width:100%;height:150vh"></div>
        <div class="proposal-overlay-content-save">
            <img src="/images/proposal-loader.gif" />
            <h1 class="align-center">{{ overlayText }}</h1>
        </div>
        <button type="button" @click="openUploadSheetModal()" class="btn btn-primary upload-sheet-button"><i class="fa fa-cloud-upload" aria-hidden="true"></i> Upload Excel Workbook</button>
    </div>
</template>
<script>

import axios from "axios";

export default {
    props: ['section', 'proposal'],
    data() {
        return {
            sheetId:null,
            sessionId:null,
            workbookControl:null,
            prizmSheetBaseURL:null,
            overlayText:'',
            server: {
                process: (fieldName, file, metadata, load, error, progress) => {
                    let self = this;
                    const formData = new FormData();
                    formData.append('file', file, file.name);
                    formData.append('sectionId', self.section.id);
                    const request = new XMLHttpRequest();
                    request.open('POST', route('prizm.upload-custom-sheet'));
                    request.upload.onprogress = (e) => {
                        progress(e.lengthComputable, e.loaded, e.total);
                    };
                    request.onload = function () {
                        if (request.status >= 200 && request.status < 300) {
                            load(request.responseText);
                            let response = JSON.parse(request.response);
                            self.documentURL = response.documentURL;
                            self.sheetEditor.destroyEditor();
                            self.loadOnlyOfficeEditor();
                        } else {
                            error('Please try again.');
                        }
                    };
                    request.send(formData);
                }
            },
            sheetEditor: null,
            editorConnectors: null,
            onlyOfficeCallBackUrl: window.location.origin+"/only-office-callback/"+this.section.id+'/sheet',
            documentKey: null,
            documentURL: null,
        }
    },
    created() {
    },
    mounted() {
        this.prizmSheetBaseURL = process.env.MIX_PRIZM_SHEET_URL;
        this.getSheetIdFromDB();

        Bus.$on('savePrizmSheetBtn', data => {
            this.saveOnlyOfficeDocument('button');
        });

        Bus.$on('saveContentSheet', data => {
            this.saveContentPrizmSheet(data);
        });

        Bus.$on('selectSheetContentToApply', data => {
            this.selectSheetContent(data);
        });

        Bus.$on('updateSheetContent', data => {
            this.updateSheetContent(data);
        });

        Bus.$on('deselectPrizmSheetContent', data => {
            $('#workbook-control-container').empty();
            this.uploadPrizmSheetWorkBook();
        });
    },
    methods: {
        uploadPrizmSheetWorkBook(){
            let self = this;
            axios.post(route('prizm.upload-sheet'))
                .then((response) => {
                    self.sheetId = response.data.response.workbookId;
                    self.updateSheetIdInSection();
                    self.createPrizmSheetSession();
                });
        },
        createPrizmSheetSession(){
            let self = this;
            this.$nextTick(()=>{
                axios.post(route('prizm.create-sheet-session'),{sheetId:self.sheetId})
                    .then((response) => {
                        self.sessionId = response.data.response.sessionId;
                        const nowDateTime = new Date();
                        const localStorageItem = {
                            sessionId: response.data.response.sessionId,
                            expiry: nowDateTime.getTime() + 3600000,
                        }
                        let sectionSessionId = 'section-sheet-session-id-'+self.section.id;
                        localStorage.setItem(sectionSessionId,JSON.stringify(localStorageItem));
                        self.createPrizmSheet();
                    });
            });
        },
        createPrizmSheet(){
            Bus.$emit('applyFirstContent', true);
            $('#workbook-control-container').empty();
            let self = this;
            this.$nextTick(async ()=> {
                const workbook = await Accusoft.WorkbookControl.create({
                    baseUrl: self.prizmSheetBaseURL,
                    sessionId: self.sessionId,
                    container: document.getElementById('workbook-control-container')
                });
                self.workbookControl = workbook;
            });

        },
        prizmSheetSave(){
            Bus.$emit('savingPrizmDoc', 'Saving...');
            // this.workbookControl.forceSave();
            this.saveOnlyOfficeDocument();
            setTimeout(()=>{
                Bus.$emit('savingPrizmDoc', 'Saved');
            }, 2000);
        },
        updateSheetIdInSection(){
            let self = this;
            this.$nextTick(()=>{
                axios.post(route('prizm.update-sheet-id-in-section'),{section:self.section,sheetId:self.sheetId})
                    .then((response) => {
                        self.sessionId = response.data.sessionId;
                        self.createPrizmSheet();
                    });
            });
        },
        getSheetIdFromDB(){
            let self = this;
            axios.post(route('proposal.only-office.get-sheet'),{sectionId:self.section.id}).then((response) => {
                this.documentURL = response.data.documentURL;
                this.$nextTick(() => {
                    this.loadOnlyOfficeEditor();
                });
            });
            // axios.post(route('prizm.get-sheet-id-of-section'),{section:self.section})
            //     .then((response) => {
            //         let sectionInfo = response.data.sectionSheetId;
            //         if(sectionInfo.sheet_id !== null){
            //             self.sheetId = sectionInfo.sheet_id;
            //             let sectionSheetSessionId = 'section-sheet-session-id-'+self.section.id;
            //             if(!localStorage.getItem(sectionSheetSessionId)){
            //                 self.createPrizmSheetSession();
            //             }else{
            //                 const itemStr = localStorage.getItem(sectionSheetSessionId);
            //                 const item = JSON.parse(itemStr);
            //                 const nowDateTime = new Date();
            //                 if (nowDateTime.getTime() > item.expiry) {
            //                     localStorage.removeItem(sectionSheetSessionId);
            //                     self.createPrizmSheetSession();
            //                 }
            //                 self.sessionId = item.sessionId;
            //                 self.createPrizmSheet();
            //             }
            //         }else{
            //             self.uploadPrizmSheetWorkBook();
            //         }
            //     });
        },
        selectSheetContent(contentId){
            let self = this;
            self.overlayText = 'Applying Content'
            $('.proposal-overlay-content-save').show();
            axios.post(route('prizm.apply-sheet-content'),{section:self.section, sessionId:self.sessionId, contentId:contentId, sheetId:self.sheetId})
                .then((response) => {
                    self.documentURL = response.data.documentURL;
                    self.overlayText = '';
                    $('.proposal-overlay-content-save').hide();
                    $('#workbook-control-container').empty();
                    self.sheetEditor.destroyEditor();
                    self.loadOnlyOfficeEditor();
                    Bus.$emit('contentAppliedSuccessfully', response.data);
                });
        },
        updateSheetContent(contentId){
            let self = this;
            $("#templateNameModal").modal("hide");
            self.overlayText = 'Updating Content'
            self.prizmSheetSave();
            $('.proposal-overlay-content-save').show();
            axios.post(route('prizm.update-sheet-content'),{contentId:contentId, sheetId:self.sheetId, sectionId: self.section.id})
                .then((response) => {
                    $('.proposal-overlay-content-save').hide();
                    self.getToast().fire({
                        type: 'success',
                        title: response.data.message
                    });
                });
        },
        saveContentPrizmSheet(data){
            event.preventDefault();
            let self = this;
            $("#templateNameModal").modal("hide");
            self.overlayText = 'Saving Content'
            self.prizmSheetSave();
            $('.proposal-overlay-content-save').show();
            axios.post(route('prizm.save-sheet-content'),{section:self.section, sessionId:self.sessionId, contentGroup:data.content_group_id, templateName: data.template_name, sheetId:self.sheetId})
                .then((response) => {
                    $('.proposal-overlay-content-save').hide();
                    self.getToast().fire({
                        type: 'success',
                        title: response.data.message
                    });
                    Bus.$emit('afterContentSaved', response.data);
                    Bus.$emit('enableSaveContentButton', true);
                });
        },
        openUploadSheetModal(){
            $('#uploadSheetModal').modal("show");
        },
        handleOnProcessFile(){
            $('#uploadSheetModal').modal("hide");
            $('#workbook-control-container').empty();
            this.sheetEditor.destroyEditor();
            this.loadOnlyOfficeEditor();
        },
        loadOnlyOfficeEditor(){
            let self = this;
            let documentKey = self.makeid(10);
            this.documentKey = documentKey;
            const config = {
                document: {
                    fileType: "xlsx",
                    key: documentKey,
                    title: "Title.xlsx",
                    url: this.documentURL,
                },
                documentType: "cell",
                editorConfig: {
                    mode: "edit",
                    callbackUrl: self.onlyOfficeCallBackUrl,
                    coEditing: {
                        mode: 'fast',
                        change: true
                    },
                    customization: {
                        uiTheme: 'theme-followup',
                        customer: {
                            name: 'FollowupCRM',
                            logo: 'https://prod-followupcrm.s3.us-east-2.amazonaws.com/profiles/zTT3YUfpIcTOcWCHW2Rmwokude2D2wvk76Y0n1J3.png'
                        },
                        forcesave: true,
                        logo: {
                            image: "https://prod-followupcrm.s3.us-east-2.amazonaws.com/profiles/zTT3YUfpIcTOcWCHW2Rmwokude2D2wvk76Y0n1J3.png",
                            imageDark: "https://prod-followupcrm.s3.us-east-2.amazonaws.com/profiles/zTT3YUfpIcTOcWCHW2Rmwokude2D2wvk76Y0n1J3.png",
                            url: "https://app.followupcrm.com/"
                        },
                        plugins: true,
                        unit: 'inch',
                        anonymous: {
                            request: true,
                            label: "Guest"
                        },
                        hideRightMenu: true
                    },
                },
                height: "900px",
                type: "desktop",
                width: "100%",
                customization: {
                    anonymous: {
                        request: true,
                        label: "Guest"
                    },
                    autosave: true
                },
                events: {
                    'onDocumentReady': function(){
                        self.editorConnectors = self.sheetEditor.createConnector();
                    },
                    'onDocumentStateChange': function(){
                        self.saveOnlyOfficeDocument(null);
                    }
                },
                permission: {
                    edit: true,
                    protect: false,
                    review: false
                }
            };
            self.sheetEditor = new DocsAPI.DocEditor("workbook-control-container", config);
            self.$nextTick(() => {
                this.setEventsForOnlyOffice();
            });
        },
        setEventsForOnlyOffice(){
            this.editorConnectors = this.sheetEditor.createConnector();
        },
        makeid(length) {
            let result = '';
            const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            const charactersLength = characters.length;
            let counter = 0;
            while (counter < length) {
                result += characters.charAt(Math.floor(Math.random() * charactersLength));
                counter += 1;
            }
            return result;
        },
        saveOnlyOfficeDocument(fromWhere){
            this.$parent.savingPrizmDoc = 'Saving...';
            axios.post(route('proposal.only-office.save-document'), {documentKey: this.documentKey, formFieldCount: 0, typeId: null, type: 'sectionSheet'})
                .then((response) => {
                    if(fromWhere){
                        this.getToast().fire({
                            type: 'success',
                            title: 'Sheet saved successfully'
                        });
                    }
                    this.$parent.savingPrizmDoc = 'Saved';
                });
        },
    },
    beforeDestroy() {
        Bus.$off('saveContentSheet');
        Bus.$off('selectSheetContentToApply');
        Bus.$off('updateSheetContent');
    },
}
</script>
<style lang="scss" escoped>
.proposal-overlay-content-save{
    position: fixed;
    display: none;
    width: 100%;
    height: 100%;
    top:18px;
    left: 0;
    right: 0;
    bottom: 0;
    //background-color: rgba(0,0,0,0.5);
    z-index: 999;
    cursor: pointer;
    background: #ffffffd9;
}
.proposal-overlay-content-save img{
    position: absolute;
    right: 42.5%;
    top: 18%;
}
.proposal-overlay-content-save h1{
    position: absolute;
    color: #01b1af;
    top: 50%;
    right: 42.5%;
    font-weight: 200;
}

.upload-sheet-button{
    position: fixed;
    bottom: 10px;
    display: block;
    right: 18vw;
}
</style>
